import HttpClient from "../services/HttpClient";
import {
  APP_URL_CONTRACT,
  CONTRACTCRITERIA,
  ERROR_MESSAGE,
  DOCUMENTCONTRACT,
  CONTRACTCANCEL,
  CONTRACTFINISH,
  REPRESENTATION,
  REPRESENTATIONCOST,
  REPRESENTATIONCOSTGENERATE,
  VALIDATEPREVIOUSCONTRACT,
} from "../constants";

export const getFilterContracts = (filter, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.post(
      `${APP_URL_CONTRACT}${CONTRACTCRITERIA}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filter,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const getDocumentContractById = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const config = { responseType: "blob" };

    HttpClient.get(
      `${APP_URL_CONTRACT}${DOCUMENTCONTRACT}/${id}`,

      config
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const updateContract = (cancelData, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.put(`${APP_URL_CONTRACT}${CONTRACTCANCEL}`, cancelData, headers)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const updateContractFinish = (body, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.put(`${APP_URL_CONTRACT}${CONTRACTFINISH}`, body, headers)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const createRepresentatationCost = (body, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.post(`${APP_URL_CONTRACT}${REPRESENTATION}`, body, headers)
      .then((response) => {
        if (response.status >= 200 && response.status < 399) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const getRepresentatationCost = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.get(`${APP_URL_CONTRACT}${REPRESENTATIONCOST}${id}`, headers)
      .then((response) => {
        if (response.status >= 200 && response.status < 399) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const generateRepresentatationCost = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.get(`${APP_URL_CONTRACT}${REPRESENTATIONCOSTGENERATE}${id}`, headers)
      .then((response) => {
        if (response.status >= 200 && response.status < 399) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const validatePreviousContract = (documentType,document, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };

    HttpClient.get(`${APP_URL_CONTRACT}${VALIDATEPREVIOUSCONTRACT}${documentType}/${document}`, headers)
      .then((response) => {
        if (response.status >= 200 && response.status < 399) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

